import React, { useState } from 'react';
import { Container, Box, Typography, TextField, Button, Paper, Grid } from '@mui/material';
import api from '../api/api';
import ErrorMessage from '../components/errorMessage';
import SuccessMessage from '../components/successMessage';
import Loading from '../components/loading';


export default function InterestedClientPage() {

    const [name, setName] = useState('');
    const [email, setEmail] = useState('');
    const [phoneNumber, setPhoneNumber] = useState('');

    const [showSuccessMessage, setShowSuccessMessage] = useState(false);
    const [successMessage, setSuccessMessage] = useState('');
    const [showErrorMessage, setShowErrorMessage] = useState(false);
    const [errorMessage, setErrorMessage] = useState('');

    const [isLoading, setLoading] = useState(false);

    const saveInterestClient = (event) => {
        event.preventDefault();

        if (!name.trim() || !email.trim() || !phoneNumber.trim()) {
            setShowErrorMessage(true);
            setErrorMessage('Por favor, preencha todos os campos.');
            return;
        }

        const input = {
            name: name,
            email: email,
            phoneNumber: phoneNumber
        };

        setLoading(true);
        api.post("/public/interested-client", input, {
        }).then((returnFromApi) => {
            setLoading(false);
            setShowSuccessMessage(true);
            setSuccessMessage(returnFromApi.data);
            cleanFields();
        }).catch((returnFromApi) => {
            setShowErrorMessage(true);
            setErrorMessage(returnFromApi.response.data);
            setLoading(false);
            console.error(returnFromApi);
        });
    };

    function cleanFields() {
        setName('');
        setEmail('');
        setPhoneNumber('');
    }

    return (
        <Box
            sx={{
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                textAlign: 'center',
                py: { xs: 6, md: 10 },
                px: 2,
            }}
        >
            <Container maxWidth="md">
                <Typography
                    variant="h4"
                    sx={{ fontWeight: 700, mb: 2 }}
                >
                    Gerencie sua clínica odontológica com facilidade e organização
                </Typography>

                <Typography
                    variant="h6"
                    color="text.secondary"
                >
                    Experimente o Sigo gratuitamente e descubra como é simples cuidar da gestão enquanto você cuida dos seus pacientes.
                </Typography>

                <Loading isToHidden={isLoading === false} />
                {showSuccessMessage && <SuccessMessage message={successMessage} show={showSuccessMessage} setShow={setShowSuccessMessage} />}
                {showErrorMessage && <ErrorMessage message={errorMessage} show={showErrorMessage} setShow={setShowErrorMessage} />}

            </Container>

            <Container maxWidth="sm">
                <Paper
                    elevation={4}
                    sx={{
                        mt: { xs: 8, md: 12 },
                        p: { xs: 3, md: 5 },
                        borderRadius: 3
                    }}
                >
                    <Typography
                        variant="h5"
                        sx={{ fontWeight: 600, mb: 4 }}
                    >
                        Comece seu teste gratuito agora
                    </Typography>

                    <Box component="form" onSubmit={saveInterestClient}>
                        <Grid container justifyContent="center">
                            <Grid container spacing={2}>
                                <Grid size={12}>
                                    <TextField
                                        fullWidth
                                        label="Nome *"
                                        value={name}
                                        onChange={(e) => setName(e.target.value)}
                                    />
                                </Grid>
                                <Grid size={12}>
                                    <TextField
                                        fullWidth
                                        type="email"
                                        label="E-mail *"
                                        value={email}
                                        onChange={(e) => setEmail(e.target.value)}
                                    />
                                </Grid>
                                <Grid size={12}>
                                    <TextField
                                        fullWidth
                                        label="WhatsApp *"
                                        value={phoneNumber}
                                        onChange={(e) => setPhoneNumber(e.target.value)}
                                    />
                                </Grid>
                                <Grid size={12}>
                                    <Button
                                        type="submit"
                                        variant="contained"
                                        color="success"
                                        sx={{
                                            py: 1.5,
                                            fontSize: '1.1rem',
                                            fontWeight: 'bold',
                                            mt: 5
                                        }}
                                    >
                                        Criar meu acesso gratuito
                                    </Button>
                                </Grid>
                            </Grid>
                        </Grid>
                    </Box>
                </Paper>
            </Container>
        </Box>
    );
}